const socialLinks = {
    facebook: 'https://www.facebook.com/AKLZOONZ',
    instagram: 'https://www.instagram.com/aucklandzoo/',
    twitter: 'https://twitter.com/aucklandzoo',
    youtube: 'https://www.youtube.com/user/aucklandzoo'
};

export default socialLinks;
